export const tabs = {
  generalTab: 'general',
  operationsTableTab: 'operations',
  partTableTab: 'parts',
};

export const action = {
  singleChecked: 'singleChecked',
  allChecked: 'allChecked',
  singleDelete: 'singleDelete',
  singleAdd: 'singleAdd',
  multipleAdd: 'multipleAdd',
  replaceAll: 'replaceAll',
};

export const handleUpdate = ({
  data = [],
  newItem = {},
  indeterminate,
  checkAll,
  actionType,
  id = null,
}) => {
  let newDataList = [];
  // check/uncheck item in the list
  if (actionType === action.singleChecked) {
    newDataList = [
      ...data?.map((o) => {
        if (o?.id === id) {
          return {
            ...o,
            addToOrder: !o?.addToOrder,
          };
        }
        return o;
      }),
    ];
  }
  // check/uncheck all items in the list
  if (actionType === action.allChecked) {
    if (indeterminate) {
      newDataList = [
        ...data?.map(o => ({
          ...o,
          addToOrder: true,
        })),
      ];
    } else if (checkAll) {
      newDataList = [
        ...data?.map(o => ({
          ...o,
          addToOrder: false,
        })),
      ];
    } else {
      newDataList = [
        ...data?.map(o => ({
          ...o,
          addToOrder: true,
        })),
      ];
    }
  }
  // delete item from the list
  if (actionType === action.singleDelete) {
    newDataList = [
      ...data?.filter(o => o.id !== id),
    ]?.map((i, index) => ({
      ...i,
      index: index + 1,
    }));
  }
  // add item to the list
  if (actionType === action.singleAdd) {
    newDataList = [
      ...data,
      newItem,
    ];
  }
  // add multiple items to the list
  if (actionType === action.multipleAdd) {
    newDataList = [
      ...data,
      ...newItem,
    ];
  }
  // replace all items in the list
  if (actionType === action.replaceAll) {
    newDataList = data;
  }
  return newDataList;
};
